var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BModal,{ref:"modal",attrs:{"title":_setup.title,"title-tag":"h2","centered":"","hide-footer":""}},[_c(_setup.ExportForm,{attrs:{"what":"workflow invocation"},on:{"export":_setup.doExport}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }